import React from 'react';

const ContactButton = ({ text = "Entrar em contato", onClick }) => {
  return (
    <a
      href="/forms"
      target="_blank"
      rel="noopener noreferrer"
    >
      <button
        onClick={onClick}
        className="bg-[#C6FF00] text-[#151342] font-bold py-4 px-8 rounded-full text-lg inline-block whitespace-nowrap hover:bg-[#151342] hover:text-[#C6FF00] border-2 border-[#C6FF00] transition-colors duration-300 hover:scale-105 animate-pulse-border"
      >
        {text}
      </button>
    </a>
  );
};

export default ContactButton;
